export interface CaptionMap {
  [index: string]: string;
}

export type SubtitleState = {
  captions: CaptionMap;
  localFile: File | null;
  disabedCaptions: string[];
  loadingCaption: string;
};

export type ActionPayload = {
  captions?: CaptionMap;
  localFile?: File | null;
  disabedCaptions?: string[];
  loadingCaption?: string;
};

export type ReducerAction = {
  type: SubtitleActionTypes;
  payload: ActionPayload;
};

export enum SubtitleActionTypes {
  Caption = 'caption',
  File = 'file',
  LoadingCaption = 'loadingCaption',
  DisabedCaptions = 'disabedCaptionsState',
}
